var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminAltaisStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.8413 16c.8317.5912 1.5759 1.3358 2.1669 2.1679.6129-.854 1.3352-1.5767 2.1669-2.1679-.8317-.5912-1.5759-1.3358-2.1669-2.1679-.591.8321-1.3352 1.5767-2.1669 2.1679z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "417368416C6F6D",
    d: "m17.2213 5.33912c-.7557-.45216-1.6869-.45216-2.4426 0l-7.55738 4.02286c-.75576.45215-1.22132 1.28782-1.22132 2.19212v8.8918c0 .9044.46556 1.74 1.22132 2.1921l7.55738 4.0229c.7557.4521 1.6869.4521 2.4426 0l7.5574-4.0229c.7557-.4521 1.2213-1.2877 1.2213-2.1921v-8.8918c0-.9043-.4656-1.73997-1.2213-2.19212zm-1.0161 4.81418c.6566 2.8029 2.8454 5.0146 5.6471 5.6496.1969.0438.1969.3285 0 .3942-2.8017.6569-5.0124 2.8467-5.6471 5.6496-.0219.1095-.1094.1533-.197.1533-.0875 0-.1751-.0438-.197-.1533-.6566-2.8029-2.8454-5.0146-5.647-5.6496-.21892-.0657-.21892-.3504 0-.3942 2.8016-.6569 5.0123-2.8467 5.647-5.6496.0219-.1095.1095-.1533.197-.1533.0876 0 .1751.0438.197.1533z",
    fillRule: "417368416C6F6D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminAltaisStar);
export default __webpack_public_path__ + "static/media/Admin-Altais-Star.e7a8b9c445ea0a1112fde17f236b4b4d.svg";
export { ForwardRef as ReactComponent };